//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#CESIUM_3D_TILE_CLASSIFICATION_IGNORE_SHOW}\n\
 *\n\
 * @name czm_passCesium3DTileClassificationIgnoreShow\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passCesium3DTileClassificationIgnoreShow = 8.0;\n\
";
